import { render, staticRenderFns } from "./YoukeXianxiaXingweiFenxi.vue?vue&type=template&id=0ce9887e&scoped=true&"
import script from "./YoukeXianxiaXingweiFenxi.vue?vue&type=script&lang=js&"
export * from "./YoukeXianxiaXingweiFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce9887e",
  null
  
)

export default component.exports